import {
  startAutoSaveTimer,
  addMissingObjRefIds,
  enableZoomButtons,
} from '~core';
import { initAlignmentSystem } from '~core/alignment/initAlignmentSystem';
import { isLoggedUserGlobalEditor } from '~src/user';
import { setCanvasEventListeners } from '~src/events';
import { checkSpelling } from '~core/spellcheck';
import { initSettings } from '~src/settings';

export const afterCanvasReady = async () => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  // Initialize settings FIRST before other systems that depend on them
  initSettings();

  // Always enable auto-save for non-global editors
  if (!isGlobalEditor) {
    await startAutoSaveTimer();
  }
  setCanvasEventListeners();
  // Initialize the new unified alignment system (now with correct settings)
  initAlignmentSystem(window.canvas);
  addMissingObjRefIds();
  await enableZoomButtons();

  // Check spelling for all textboxes after canvas is ready
  // Use setTimeout to ensure canvas is fully initialized and avoid conflicts with render loop prevention
  setTimeout(async () => {
    try {
      await checkSpelling(window.canvas);
      // Force a render to ensure spell check underlines are visible
      window.canvas.requestRenderAll();
    } catch (error) {
      console.error('Error checking spelling after canvas ready:', error);
    }
  }, 100);
};
